import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import AddressForm from "./AddressForm";
import I18n from 'i18n.js.erb'
import {EMPTY_ADDRESS, isDefined, isValidUserAddress, parseAmount, parseShipmentAddress} from "../../utils/utils";

const SubmissionListAddressFormContainerModal = ({
  editable,
  submissionList,
  addressType,
  address,
  setAddress,
  userAddresses,
  setUserAddresses,
  countries,
  setShowSuccessFlashMessage,
  setShowErrorModal
}) => {

  const [showModal, setShowModal] = useState(false);
  const [addressId, setAddressId] = useState(address.id);
  const [newAddress, setNewAddress] = useState(EMPTY_ADDRESS);
  const [formSubmitted, setFormSubmitted] = useState(false);

  // console.log('userAddresses: ', userAddresses);
  // console.log('countries: ', countries);
  // console.log('addressId: ', addressId);


  useEffect(() => {
    setAddressId(address.id);
  }, [showModal]);


  useEffect(() => {
    if (addressId !== 'new_address')
      setNewAddress(EMPTY_ADDRESS);
  }, [addressId]);


  // Funzione che aggiorna i parametri del nuovo indirizzo
  const updateNewAddressParams = (keys, values) => {
    const updatedNewAddress = {...newAddress};
    for (let i = 0; i < keys.length; i++)
      updatedNewAddress[keys[i]] = values[i]
    setNewAddress(updatedNewAddress)
  }


  // Funzione che aggiorna l'indirizzo di ritiro a domicilio / consegna di ritorno
  // scelto dall'utente per la submission list
  const handleConfirm = () => {
    setFormSubmitted(true);

    if (editable && isDefined(addressId) && (isValidUserAddress(newAddress) || addressId !== 'new_address')) {
      let url = `/submission_lists/update_address/${submissionList.id}.json`;

      const body = {
        'address_type': addressType,
        'address_id': addressId
      }
      if (addressId === 'new_address')
        body ['new_address'] = newAddress;

      fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          const address = data[addressType];

          if (addressId === 'new_address') {
            let updatedUserAddresses = userAddresses;
            if (address.residence)
              updatedUserAddresses = updatedUserAddresses.map(address => {
                return { ...address, residence: false };
              });
            setUserAddresses([ ...updatedUserAddresses, { ...address } ]);
          }

          setAddress(address);
          handleCloseModal();

          if (setShowSuccessFlashMessage)
            setShowSuccessFlashMessage(true);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setFormSubmitted(false);
          if (setShowErrorModal)
            setShowErrorModal(true);
        });

    }
  }


  // Funzione che si occupa di chiudere la modale che permette all'utente di cambiare l'indirizzo di ritiro a
  // domicilio / consegna di ritorno per la submission list
  const handleCloseModal = () => {
    setShowModal(false);
    setNewAddress(EMPTY_ADDRESS);
    setFormSubmitted(false);
  }




  return (
    <React.Fragment>
      {
        editable &&
          <div className="mt-4">
            <p className="my-0">{I18n.t(`js.editSubmissionListPage.change_${addressType}_txt`)}</p>
            <p className="my-0 cursor-pointer text-underline-imp text-aiBlue"
               onClick={(e) => setShowModal(true)}>
              {I18n.t("js.editSubmissionListPage.changeAddress")}
            </p>
          </div>
      }

      <Modal
        size="lg"
        show={showModal}
        onHide={handleCloseModal}
        animation={false}
      >
        <Modal.Body>
          <div className="font-jost px-4 py-2">
            <div className="border-bottom-aiBlue-2px mb-4">
              <h4 className="mb-1">
                <b>
                  {I18n.t(`js.editSubmissionListPage.change_${addressType}`)}
                </b>
              </h4>
            </div>

            <div className="pl-3">
              {
                userAddresses.map(a => {
                  const shipmentAvailableByProvince = address.id == a.id || countries[a.country_id]['provinces'].includes(a.province);

                  return <div id={'address_' + a.id} key={'address_' + a.id}
                              className="row px-4 pt-3 w-100 text-left custom-control custom-radio">
                    <input
                      type="radio"
                      id={'input_address_' + a.id}
                      name={'input_address_' + a.id}
                      value={a.id}
                      className="aiG-radio custom-control-input"
                      disabled={!shipmentAvailableByProvince}
                      checked={addressId == a.id}
                      onChange={() => setAddressId(a.id)}
                    />
                    <label
                      className="aiG-label-radio custom-control-label font-weight-normal"
                      id={"label_address_" + a.id}
                      htmlFor={'input_address_' + a.id}
                    >
                      {
                        a.residence &&
                        <p className="mb-0">
                          <b>{I18n.t('js.newUserAddressForm.residenceCompact')}</b>
                        </p>
                      }
                      {parseShipmentAddress(a)}
                      {
                        !shipmentAvailableByProvince &&
                          <p className="mb-0">
                            <b>{I18n.t(`js.editSubmissionListPage.webComponent.draft.${addressType.replaceAll('_address', '')}NotAvailableOnThisProvince`)}</b>
                          </p>
                      }
                    </label>
                  </div>
                })
              }
            </div>


            <div className="row mx-0" id="new-address">
              <p className="font-weight-bold cursor-pointer text-blue cursor-pointer my-4"
                 onClick={() => setAddressId('new_address')}
                >
                {I18n.t('js.newUserAddressForm.title_use_new_address')}
              </p>

              {
                addressId === 'new_address' &&
                  <AddressForm
                    shipmentAddress={newAddress}
                    updateShipmentAddressParams={updateNewAddressParams}
                    countries={countries}
                    canUpdate={true}
                    addressType={'user'}
                    formSubmitted={formSubmitted}
                  />
              }
            </div>



            <div className="d-flex justify-content-between w-100 mx-0 pt-4">
              <div>
                <button
                  type="button"
                  className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={handleCloseModal}
                >
                  {I18n.t('js.common.button.cancel').toUpperCase()}
                </button>
              </div>

              <div>
                <button
                  type="button"
                  className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                  onClick={handleConfirm}
                >
                  {I18n.t('js.common.button.confirm').toUpperCase()}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default SubmissionListAddressFormContainerModal;